import React from 'react';
import { FaHistory } from 'react-icons/fa';
import ComingSoon from './ComingSoon';

interface HistoryProps {
  isPremium: boolean;
}

const History: React.FC<HistoryProps> = ({ isPremium: _isPremium }) => {
  return (
    <ComingSoon
      title="履歴機能"
      description="作成したリライト結果の履歴を管理・検索・再利用できる機能を準備中です。"
      icon={FaHistory}
      features={[
        "リライト履歴の保存・管理",
        "高度な検索・フィルター機能", 
        "履歴からエディタへの読み込み",
        "統計情報とレポート",
        "データのエクスポート・インポート"
      ]}
    />
  );
};

export default History;